import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  App, Table, Row, Col, Popover, Divider, Button, List, Typography, Empty, Input, Select, Space
} from 'antd';
import { CheckOutlined, DeleteOutlined } from '@ant-design/icons';
import styles from './summary.module.css';
import QtyChangerCart from '../QtyChangerCart';
import { addToCart, removeFromCart } from '../../actions/cart';

const { Text, Link, Title } = Typography;

export default function BuyerOrderSummary() {
  const { message } = App.useApp();
  const dispatch = useDispatch();
  const myRef = useRef();
  const cartProducts = useSelector((state) => state.cart.products);
  const productsTotal = useSelector((state) => state.cart.productsTotal);
  const cartTotal = useSelector((state) => state.cart.cartTotal);
  const shippingValue = useSelector((state) => state.cart.shippingValue);
  const cartAuxInfo = useSelector((state) => state.cart.cartAuxInfo);
  const paymentDiscountValue = useSelector((state) => state.cart.paymentDiscountValue);
  const logged = useSelector((state) => state.authentication.logged);
  const sellerData = useSelector((state) => state.sellerData);
  const onlineStatus = useSelector((state) => state.sync.onlineStatus);
  const cart = useSelector((state) => state.cart);
  const campaigns = useSelector((state) => state.campaigns.campaigns);


  const [editPrice, setEditPrice] = useState(null);
  const [newPrice, setNewPrice] = useState(null);

  const [inputValue, setInputValue] = useState('');
  const [editDiscount, setEditDiscount] = useState(false);


  const getProductPrice = (product, qtyInCart) => {
    const priceModified = product.price_modified;
    const priceCampaign = product.product_price_campaign;
    const priceSale = product.product_price_sale;
    const priceBulkConditions = product.product_price_bulk;
    const priceBulk = priceBulkConditions
      ? Object.entries(priceBulkConditions).reduce((acc, [minQty, price], i, entries) => {
        const nextMin = entries[i + 1]?.[0];
        return qtyInCart >= minQty && (!nextMin || qtyInCart < nextMin) ? price : acc;
      }, null)
      : null;

    const candidates = [
      priceBulk != null && { type: 'bulk', price: priceBulk },
      priceCampaign != null && { type: 'campaign', price: priceCampaign },
      priceSale != null && { type: 'sale', price: priceSale },
      { type: 'normal', price: product.product_price }
    ].filter(Boolean);

    const best = candidates.reduce((prev, curr) =>
      curr.price < prev.price ? curr : prev
    );

    const priceFinalWithoutModified = best.price;
    let final_type = best.type;
    const priceFinal = priceModified != null ? priceModified : priceFinalWithoutModified;

    if (priceModified != null) {
      final_type = 'modified';
    }

    return {
      priceFinal,
      priceFinalWithoutModified,
      final_type,
      priceBulk,
      priceModified,
      priceCampaign,
      priceSale
    };
  };

  function dealWithSubmit(product) {
    setEditPrice(null);
    const actualPrice = product.product_price_sale ? product.product_price_sale : product.product_price;
    (parseFloat(newPrice) === actualPrice || newPrice === null) ? dispatch({ type: 'REMOVE_MODIFY_PRICE', product }) : dispatch({ type: 'MODIFY_PRICE', product, price_modified: newPrice });
    dispatch({ type: 'SET_CART', updated: true, returned: false });
  }

  const updateDiscount = (value) => {
    if (value === null) {
      const newCartAuxInfo = { ...cart.cartAuxInfo };
      delete newCartAuxInfo.sellerDiscountPercentage;
      dispatch({
        type: 'SET_CART',
        cartAuxInfo: newCartAuxInfo,
        updated: true,
        returned: false
      });
      return;
    }

    const maxAllowedDiscount = logged === 'seller' ? 100 : sellerData.permissions.configuration?.max_discount_percentage;

    const discount = parseFloat(value ?? inputValue);
    if (!isNaN(discount)) setInputValue(discount);
    if (isNaN(discount) || discount < 0) {
      message.error('Desconto não pode ser negativo ou inválido');
    } else if (discount <= maxAllowedDiscount) {
      dispatch({ type: 'SET_CART', cartAuxInfo: { sellerDiscountPercentage: discount }, updated: true, returned: false });
      setEditDiscount(false);
    } else {
      message.error(`Seu desconto máximo permitido é ${maxAllowedDiscount}%`);
    }
  };

  useEffect(() => {
    if (myRef && myRef.current) {
      const { input } = myRef.current;
      input.focus();
    }
  });

  function CartRow(props) {
    const { product } = props;
    const qty = product.quantity;

    const { final_type, priceFinal, priceFinalWithoutModified, priceBulk, priceModified, priceCampaign } = getProductPrice(product, qty);

    // cálculo de imagem
    let imgSrc = null;
    if (onlineStatus) {
      if (product.product_image?.[0]) {
        imgSrc = product.product_image[0].thumbnail;
      }
    } else if (onlineStatus === false && syncStatus === 'synced') {
      imgSrc = localStorage.getItem(`products_${product.id}`);
    }

    // render
    return (
      <List.Item key={product.product_sku}>
        <div className={styles['card-item']}>
          <div className={styles['img-container']}>
            <img
              className={styles['product-img']}
              src={imgSrc || '/fallback.png'}
              alt=""
            />
          </div>
          <div className={styles.product_info}>
            <div className={styles.product_name}>
              {product.product_name}
            </div>
            <div className={styles['product-calc']}>
              <div>
                <span>
                  {(logged === 'seller' ||
                    (logged === 'sellerUser' && sellerData.permissions.configuration.modify_price_in_cart))
                    ? editPrice === product.id
                      ? (
                        <Space.Compact>
                          <Input
                            onBlur={() => setEditPrice(null)}
                            type="number"
                            pattern="\d*"
                            size="small"
                            prefix="R$"
                            value={newPrice}
                            style={{ width: '60%' }}
                            onChange={e => setNewPrice((parseInt(e.target.value.replace(/\D/g, '')) / 100).toFixed(2))}
                            ref={myRef}
                            onPressEnter={() => dealWithSubmit(product)}
                          />
                          <Button
                            onMouseDown={() => dealWithSubmit(product)}
                            size="small"
                            type="primary"
                          >
                            <CheckOutlined />
                          </Button>
                        </Space.Compact>
                      )
                      : (
                        <div style={{ lineHeight: '110%' }}>
                          <Popover
                            content={
                              <>
                                <Table
                                  size="small"
                                  showHeader={false}
                                  pagination={false}
                                  columns={[
                                    { title: 'Tabela', dataIndex: 'discount', key: 'discount', width: '50%' },
                                    {
                                      title: 'Preço',
                                      dataIndex: 'price',
                                      key: 'price',
                                      width: '50%',
                                      render: (text, record) => (
                                        <Link
                                          onClick={() => {
                                            if (record.key === 'original') {
                                              if (priceBulk || priceCampaign) {
                                                const original = parseFloat((product.product_price_sale ?? product.product_price).toFixed(2));
                                                dispatch({ type: 'MODIFY_PRICE', product, price_modified: original });
                                              } else {
                                                dispatch({ type: 'REMOVE_MODIFY_PRICE', product });
                                              }
                                            } else {
                                              const modified = parseFloat(text.replace('R$', '').replace(',', '.'));
                                              dispatch({ type: 'MODIFY_PRICE', product, price_modified: modified });
                                            }
                                            dispatch({ type: 'SET_CART', updated: true, returned: false });
                                          }}
                                        >
                                          {text}
                                        </Link>
                                      ),
                                    },
                                  ]}
                                  dataSource={[
                                    {
                                      key: 'original',
                                      discount: 'Original',
                                      price: `R$ ${(product.product_price_sale ?? product.product_price).toFixed(2)}`,
                                    },
                                    ...(priceCampaign
                                      ? [{
                                        key: 'campanha',
                                        discount: 'Campanha',
                                        price: `R$ ${priceCampaign.toFixed(2)}`,
                                      }]
                                      : []),
                                    ...(priceBulk
                                      ? [{
                                        key: 'progressivo',
                                        discount: 'Progressivo',
                                        price: `R$ ${priceBulk.toFixed(2)}`,
                                      }]
                                      : []),
                                  ]}
                                />
                                <Link
                                  onClick={() => setEditPrice(product.id)}
                                  style={{ display: 'block', marginTop: 8 }}
                                >
                                  Outro Valor
                                </Link>
                              </>
                            }
                            trigger="click"
                            placement="topLeft"
                            onVisibleChange={visible => !visible && setEditPrice(null)}
                          >
                            {'price_modified' in product
                              ? (
                                <>
                                  <Text delete>
                                    R$ {priceFinalWithoutModified.toFixed(2)}
                                  </Text>
                                  <br />
                                  <Link>
                                    {`R$${parseFloat(priceModified).toFixed(2)} `}
                                  </Link>
                                </>
                              )
                              : (
                                <Link style={{ color: (final_type == 'campaign' || final_type == 'bulk') ? 'orange' : undefined }}>
                                  R$ {priceFinal}
                                </Link>
                              )
                            }
                            x {qty} = R$ {(qty * priceFinal).toFixed(2)}
                          </Popover>
                        </div>
                      )
                    : (
                      <Text>
                        R$ {priceFinal} x {qty} = R$ {(qty * priceFinal).toFixed(2)}
                      </Text>
                    )
                  }
                </span>
              </div>
              <QtyChangerCart addToCart={addToCart} product={product} quantity={qty} />
            </div>
          </div>
          <DeleteOutlined
            onClick={() => {
              dispatch(removeFromCart(product));
              dispatch({ type: 'CART_UPDATED', updated: true });
              dispatch({ type: 'CART_RETURNED', returned: false });
            }}
            style={{ color: 'red' }}
          />
        </div>
      </List.Item>
    );
  }

  return (
    <>
      <Divider orientation="left">Resumo do Pedido</Divider>
      <div className={styles['summary-card']}>
        <div className={styles['product-list']}>
          <List
            itemLayout="vertical"
            dataSource={cartProducts}
            renderItem={(product) => (
              <CartRow product={product} />
            )}
            locale={{
              emptyText: <Empty description={
                <Text>
                  Seu carrinho está vazio
                </Text>
              } />,
            }}
          />
        </div>
        <Divider />
        <div style={{ paddingLeft: '5%', paddingRight: '5%' }}>
          {productsTotal && (
            <div className={styles.order_total}>
              <p>Total dos Produtos</p>
              <h4>
                R$
                {parseFloat(productsTotal).toFixed(2)}
              </h4>
            </div>
          )}
          {logged === 'buyer' && cartAuxInfo.appliedCampaign ? (
            <Row justify="space-between" align="middle">
              <Col>
                <Text style={{ color: 'orange' }}>
                  {cartAuxInfo.appliedCampaign.value_or_percentage === 'percent'
                    ? `Campanha (-${cartAuxInfo.appliedCampaign.discount_value}%)`
                    : `Campanha (-R$ ${cartAuxInfo.appliedCampaign.discount_value})`}
                </Text>
              </Col>
              <Col>
                <Title level={5} style={{ margin: 0, padding: 0 }}>
                  - R$ {cartAuxInfo.appliedCampaign.amount.toFixed(2)}
                </Title>
              </Col>
            </Row>
          ) : null}
          {(logged === 'seller' || (logged === 'sellerUser' && sellerData.permissions.configuration?.max_discount_percentage > 0)) && <>
            {!editDiscount ?
              <Popover
                content={
                  <>
                    {(campaigns && campaigns.filter(c => c.action === 'discountCart').length > 0 && <div style={{ maxWidth: 300 }}>
                      <Table
                        size="small"
                        showHeader={false}
                        pagination={false}
                        columns={[
                          {
                            title: 'Campanha',
                            dataIndex: 'name',
                            key: 'name',
                            width: '80%',
                            ellipsis: true,
                          },
                          {
                            title: 'Desconto',
                            dataIndex: 'discount_value',
                            key: 'discount_value',
                            width: '20%',
                            render: (text, record) => (
                              <Link
                                onClick={() => {
                                  dispatch({
                                    type: 'SET_CART',
                                    cartAuxInfo: {
                                      ...cart.cartAuxInfo,
                                      overwritedCampaign: record,
                                      sellerDiscountPercentage: null,
                                    },
                                    updated: true,
                                    returned: false,
                                  });
                                }}
                              >
                                {record.value_or_percentage === 'percent'
                                  ? `${record.discount_value}%`
                                  : `R$ ${record.discount_value}`}
                              </Link>
                            ),
                          },
                        ]}
                        dataSource={campaigns && campaigns.filter(c => c.action === 'discountCart')}
                      />
                    </div>

                    )}
                    <Link
                      onClick={() => setEditDiscount(true)}
                      style={{ display: 'block', marginTop: 8 }}
                    >
                      Outro Valor
                    </Link>
                    {(cartAuxInfo.sellerDiscountPercentage > 0 || cartAuxInfo.appliedCampaign) && (
                      <Link
                        onClick={() => updateDiscount(0)}
                        style={{ display: 'block', marginTop: 8, color: 'red' }}
                      >
                        Remover Desconto
                      </Link>
                    )}
                  </>
                }
                trigger="click"
                placement="topLeft"
                onVisibleChange={visible => !visible && setEditPrice(null)}
              >
                <Row justify="space-between" align="middle">
                  <Col>
                    {cartAuxInfo.sellerDiscountPercentage > 0 ? (
                      <Link>Desconto (-{cartAuxInfo.sellerDiscountPercentage}%)</Link>
                    ) : cartAuxInfo.appliedCampaign ? (
                      <Link style={{ color: 'orange' }}>
                        {cartAuxInfo.appliedCampaign.value_or_percentage === 'percent'
                          ? `Campanha (-${cartAuxInfo.appliedCampaign.discount_value}%)`
                          : `Campanha (-R$ ${cartAuxInfo.appliedCampaign.discount_value})`}
                      </Link>
                    ) : <Link>Adicionar Desconto</Link>}
                  </Col>
                  <Col>
                    {cart.productsTotal > 0 && (
                      cartAuxInfo.sellerDiscountPercentage != null && cartAuxInfo.sellerDiscountPercentage > 0 ? (
                        <Title level={5} style={{ margin: 0, padding: 0 }}>
                          - R$ {(cartAuxInfo.sellerDiscountPercentage / 100 * productsTotal).toFixed(2)}
                        </Title>
                      ) : cartAuxInfo.appliedCampaign?.amount > 0 ? (
                        <Title level={5} style={{ margin: 0, padding: 0 }}>
                          - R$ {cartAuxInfo.appliedCampaign.amount.toFixed(2)}
                        </Title>
                      ) : null
                    )}
                  </Col>
                </Row>
              </Popover> : <></>}
            {editDiscount && <Input.Group style={{ display: "flex", justifyContent: "start" }} compact>
              <Select
                disabled
                style={{ width: "110px" }}
                size="small"
                defaultValue="Desconto"
                options={[{ value: 'discount', label: 'Desconto' }]}
              />
              <Input
                size="small"
                type="number"
                pattern="\d*"
                style={{ width: '80px' }}
                suffix="%"
                value={inputValue}
                onChange={(e) => {
                  let value = e.target.value;
                  if (/^\d*\.?\d*$/.test(value)) {
                    value = value.replace(/^0+(?![\.|$])/, '');
                    setInputValue(value === '' ? '0' : value);
                  }
                }}
                onKeyDown={(e) => e.key === 'Enter' && updateDiscount()}
              />
              <Button size="small" type="primary" onClick={() => updateDiscount()}>
                <CheckOutlined />
              </Button>
            </Input.Group>
            }
          </>}
          {paymentDiscountValue > 0 && (
            <div className={styles.order_total}>
              <p>Desconto (Pagamento)</p>
              <h4>
                - R$
                {paymentDiscountValue.toFixed(2)}
              </h4>
            </div>
          )}
          <div className={styles.order_total}>
            <p>Frete</p>
            <h4>
              R$
              {parseFloat(shippingValue).toFixed(2)}
            </h4>
          </div>
          <div className={styles.order_total}>
            <h2>Total</h2>
            <h2>
              R$
              {parseFloat(cartTotal).toFixed(2)}
            </h2>
          </div>
        </div>
      </div>
    </>
  );
}
